import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3d6f76eb&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "App.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/App.vue
// module id = 829
// module chunks = 1